import React from 'react';
import { Alert } from 'react-bootstrap';
import classes from './view-alert.module.css';

const ViewAlert = ({ show = false, message = '', errors = [], clearMessage }) => {
	message = message === '' && errors.length > 0 ? 'Errors' : message;

	return (
		message && (
			<Alert show={message !== ''} variant={errors.length > 0 ? 'danger' : 'success'} onClose={() => clearMessage()} dismissible>
				<Alert.Heading className={classes['alert-heading']}>{message}</Alert.Heading>
				<div className={classes['alert-body']}>
					{errors.map((err, i) => (
						<p key={i}>[{err}]</p>
					))}
				</div>
			</Alert>
		)
	);
};

export default ViewAlert;
